import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { createLead } from "../../api";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // only numbers
    if (value.length <= 10) {
      setFormData({ ...formData, phone: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.subject ||
      !formData.message
    ) {
      setErrorMsg("Please fill all fields");
      return;
    }

    if (formData.phone.length !== 10) {
      setErrorMsg("Phone number must be exactly 10 digits");
      return;
    }

    try {
      setLoading(true);
      const res = await createLead(formData);

      console.log("Lead Response:", res.data);

      if (res.data.success === true) {
        setSuccessMsg("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        setErrorMsg("Failed to send message");
      }
    } catch (err) {
      setErrorMsg("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section className="contact-hero">
        <Container>
          <Row>
            <Col md={12}>
              <h1>Contact BR Travel</h1>
              <p>
                We’d love to hear from you. Let’s plan your next unforgettable journey together.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <Container>
          <Row className="g-4">
            {/* Contact Info */}
            <Col md={4}>
              <div className="contact-info-card">
                <h4>Get in Touch</h4>
                <p>
                  Reach out to us for travel planning, enquiries, or partnerships.
                </p>

                <div className="info-item">
                  <i className="bi bi-geo-alt"></i>
                  <span>B12, 2nd Floor, Panchsheel Enclave New Delhi-110017</span>
                </div>

                <div className="info-item">
                  <i className="bi bi-envelope"></i>
                  <span>bipnesh@brtravels.co.in</span>
                </div>

                <div className="info-item">
                  <i className="bi bi-envelope"></i>
                  <span>ops@brtravels.co.in</span>
                </div>

                <div className="info-item">
                  <i className="bi bi-telephone"></i>
                  <span>+91 9650801697</span>
                </div>

                <div className="info-item">
                  <i className="bi bi-file-earmark-text"></i>
                  <span>GST NUMBER : 07AKEPM1902B1ZT</span>
                </div>
              </div>
            </Col>

            {/* Contact Form */}
            <Col md={8}>
              <div className="contact-form-card">
                <h4>Send Us a Message</h4>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Your Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Your Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Phone Number"
                          name="phone"
                          value={formData.phone}
                          onChange={handlePhoneChange}
                          maxLength={10}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      placeholder="Write your message here..."
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  {errorMsg && <p className="error-text">{errorMsg}</p>}
                  {successMsg && <p className="success-text">{successMsg}</p>}

                  <Button className="contact-btn" type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Send Message"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
